<template>
  <div>
    <div class="gmf-mb-4">
      <DropdownSelect v-model="sortingMethod" :options="sortingMethods" />
    </div>
    <VerticalSeparator v-if="tokenBalanceItems.length">
      {{ t('tokens') }}
    </VerticalSeparator>
    <ItemGrid v-if="tokenBalanceItems.length" :items="tokenBalanceItems" :columns="2" class="gmf-item-grid-tokens" />
    <VerticalSeparator v-if="lootCrates.length">
      {{ t('loot_crates') }}
    </VerticalSeparator>
    <ItemGrid v-if="lootCrates.length" :items="lootCrates" :columns="2" @select="clickItem" />
    <VerticalSeparator v-if="sortedItems.length">
      {{ t('unlocks') }}
    </VerticalSeparator>
    <ItemGrid :items="sortedItems" :columns="2" @select="clickItem" showColors />
  </div>
</template>
<style>
.gmf-inventory-menu .gmf-horizontal-pills-menu {
  padding-inline: 0;
}
</style>
<script>
import state from '@/state';
import ItemGrid from '@/components/Items/ItemGrid.vue';
import DropdownSelect from '@/components/DropdownSelect';
import callApi from '@/utils/callApi';
import VerticalSeparator from '@/components/VerticalSeparator';
import eventbus from '@/utils/eventbus';
import { getMyTokenBalance } from '@/utils/getMyTokenBalance';

const t = state.t.prefix('inventory');

export default {
  components: { ItemGrid, DropdownSelect, VerticalSeparator },
  data() {
    return {
      balances: null,
      inventory: null,
      sortingMethod: 'rarity_desc',
      raritySortOrder: {
        unobtainable: 0,
        rare: 1,
        uncommon: 2,
        common: 3,
        basic: 4,
      },
      selectedItem: null,
    };
  },
  props: {
    /**
     * Provide customer id here to load achievements for another customer,
     * instead of the one currently logged in.
     */
     customerId: {
      Type: Number,
      default: null,
    },
  },
  async created () {
    this.loadInventory();

    if (this.isMyProfile) {
      state.tokenBalances = await getMyTokenBalance();
    }
  },
  mounted () {
    eventbus.on('openedLootCrate', this.loadInventory);
  },
  beforeUnmount () {
    eventbus.off('openedLootCrate', this.loadInventory);
  },
  computed: {
    tokenBalanceItems () {
      if (! state.tokenBalances) {
        return [];
      }

      return state.tokenBalances.map(tokenBalance => {
        return {
          name: tokenBalance.token.name + ' x ' + tokenBalance.amount,
          url: tokenBalance.token.itemIcon,
        };
      });
    },
    isMyProfile() {
      return state.profile && this.customerId === state.profile.id;
    },
    sortingMethods () {
      return [
        {
          label: t('rarity'),
          value: 'rarity_desc',
        },
        {
          label: t('last_unlocked'),
          value: 'last_unlocked',
        },
        // {
        //   label: t('name'),
        //   value: 'name_asc',
        // },
      ];
    },
    lootCrates () {
      if (! this.inventory) {
        return [];
      }
      return this.inventory.filter(item => item.type === 'loot-crate');
    },
    sortedItems () {
      if (! this.inventory) {
        return [];
      }
      const items = this.inventory.filter(item => item.type !== 'loot-crate');
      items.sort((a, b) => {
        if (this.sortingMethod === 'rarity_desc') {
          return this.raritySortOrder[a.rarity] - this.raritySortOrder[b.rarity];
        } else if (this.sortingMethod === 'name_asc') {
          return a.name.localeCompare(b.name);
        } else if (this.sortingMethod === 'last_unlocked') {
          return new Date(b.metadata.unlockedAt) - new Date(a.metadata.unlockedAt);
        }

        return 0;
      });
      return items;
    },
  },
  methods: {
    t,
    clickItem (item) {
      this.selectedItem = item;
    },
    async loadInventory () {
      this.inventory = null;
      this.selectedItem = null;

      const res = await callApi('GET', '/v1/client/inventory/' + this.customerId);

      if (res.status === 401) {
        return null;
      }

      this.inventory = await res.json();
    },
  },
};
</script>